import { useEffect, useState } from 'react';

import licenseApi from '../api/licenseApi';

export const useIsLicenseActive = () => {
    const [isLicenseActive, setIsLicenseActive] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        void licenseApi.getIsLicenseActive().then(result => {
            setIsLicenseActive(result);
            setIsLoading(false);
        });
    }, []);

    return {
        isLicenseActive,
        isLoading,
    };
};
